import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { go } from '@epicuro-next/state/router-store';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Store } from '@ngrx/store';

@Component({
  selector: 'epc-nav-link',
  templateUrl: './nav-link.component.html',
  styleUrls: ['./nav-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavLinkComponent {
  @Input()
  public listGroupAction: boolean;
  @Input()
  public label: string;
  @Input()
  public route: string;
  @Input()
  public name: string;
  @Input()
  public queryParams: { [k: string]: unknown };
  @Input()
  public isActive = false;
  @Input()
  public iconOnly = false;
  @Input()
  public icon: IconDefinition;

  @HostBinding('class')
  @Input()
  public hostClassList: string;

  @Output()
  public navigation = new EventEmitter<Event>();

  constructor(private router: Router, private store: Store) {}

  public navigate(event: Event) {
    event.preventDefault();
    this.navigation.emit(event);
    this.router.navigate([{ outlets: { overlay: null } }]).then(() => {
      this.store.dispatch(
        go({
          commands: [this.route],
          extras: {
            queryParams: this.queryParams,
            queryParamsHandling: 'merge',
          },
        }),
      );
    });
  }
}
